import React, { Suspense } from 'react';
import Button from '../ui/button';
import mapboxgl from '!mapbox-gl';
import * as style from './contactCallout.module.scss';
import Loading from '../global/loading';

mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_TOKEN;

class ContactCallout extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/outrider/cjgf4hurg001h2slzilh8wz33',
      center: [-89.37482820000002, 43.08108199999999],
      attributionControl: false,
      zoom: 11,
      interactive: false,
    }).addControl(
      new mapboxgl.AttributionControl({
        compact: true,
      })
    );

    const marker = new mapboxgl.Marker()
      .setLngLat([-89.37482820000002, 43.08108199999999])
      .addTo(this.map);

    this.map.on('load', () => {
      window.addEventListener('resize', this.handleResize);
      this.map.resize();
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    this.map.remove();
  }
  handleResize = () => {
    this.map.resize();
  };

  render() {
    const isSSR = typeof window === "undefined";
    return (
      <>
      {!isSSR && (
      <Suspense fallback={<Loading/>}>
        <div className={`container-component ${style.contactCallout}`}>
          <div className={`${style.colLeft}`}>
            <div
              className={style.mapContainer}
              ref={el => (this.mapContainer = el)}
            />
          </div>
          <div className={`${style.colRight}`}>
            <div
              className={`typeFonts1 ${style.line}`}
              dangerouslySetInnerHTML={{ __html: this.props.text }}
            />
            <Button
              color="white"
              to={this.props.cta_link.url}
              text={this.props.cta_link.title}
              target="external"
            />
          </div>
        </div>
      </Suspense>
      )}
      </>
    );
  }
}

export default ContactCallout;
